import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { MemberMessage } from 'features/members';
import { useNavigateToCreateChatWithUser, useNavigateToMemberProfile } from './hooks';

type Params = {
  memberId: string;
};

const PageMemberMessage = () => {
  const { memberId } = useRequiredParams<Params>();
  const navigateToChat = useNavigateToCreateChatWithUser();
  const navigateToProfile = useNavigateToMemberProfile();

  return (
    <AppLayout>
      <MemberMessage memberId={memberId} navigateToChat={navigateToChat} navigateToProfile={navigateToProfile} />
    </AppLayout>
  );
};

export default PageMemberMessage;
